module.exports = __webpack_public_path__ + "img/Logo-Era-Tua-Hair.ca5ac10.svg";